import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_GET_DOWNLOAD_AUTH_DETAILS_DATA_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_GET_DOWNLOAD_AUTH_DETAILS_DATA_REQUEST`;
export const INTELLIGENT_PHOTO_CAPTURE_GET_DOWNLOAD_AUTH_DETAILS_DATA_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_GET_DOWNLOAD_AUTH_DETAILS_DATA_SUCCESS`;
export const photoCaptureIntelligentGetDownloadAuthDetailsDataAction = (coCode, contextId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_GET_DOWNLOAD_AUTH_DETAILS_DATA_REQUEST,
    payload: { coCode, contextId }
});
export const photoCaptureIntelligentGetDownloadAuthDetailsDataSuccessAction = photoCaptureDownloadAuthenticationData => ({
    type: INTELLIGENT_PHOTO_CAPTURE_GET_DOWNLOAD_AUTH_DETAILS_DATA_SUCCESS,
    payload: { photoCaptureDownloadAuthenticationData }
});
//# sourceMappingURL=photoCaptureIntelligentDownloadAuthDetailsAction.js.map